<template>

  <div :class="{ 'show':getCount,'studioIntroBox':1 }"  @click="clickIntro($event)">
    <div>
      <em class="closeBtn" @click="closeIntroFn"></em>
        <h3 class="enFont">CLOUD PARK <br/>DESIGN</h3>
        <h5>天安云谷设计工作室</h5>
        <p>品牌策划与设计工作室隶属于深圳天安云谷产城社区研究院旗下，我们深信品牌的力量，深耕云谷，亦服务于云谷。</p>
        <p>基于云谷品牌的成功打造经验，我們整合商业思考、美学价值及技术实现，专注于为园区企业及商家提供品牌创意策划、新媒体策划、互联网产品设计等相关服务。致力通过创新的设计理念和品牌运营之道，帮助客户构建卓越的品牌体系，塑造高端优质的品牌形象。</p>

        
        <ul>
          <li>
              <img src="../assets/images/studioIntro1.png" />
              <p>品牌创意<br/>策划及设计</p>
          </li>
          <li>
              <img src="../assets/images/studioIntro2.png" />
              <p>新媒体创意<br/>策划及设计</p>
          </li>
          <li>
              <img src="../assets/images/studioIntro3.png" />
              <p>产品体验<br/>策划及设计</p>
          </li>
        </ul>
        

        <div class="introFoot clearfix">
          <p class="numFont tel fl">TEL:0755-89331616</p>
          <P class="email fr">Email:wugang@szyungu.com</P>
          <p class="address fl">深圳市龙岗坂田街道雪岗路2018号天安云谷一期3栋B座32楼</p>
        </div>
    </div>
  </div>

</template>

<script>
  export default {
    name: 'StudioIntro',
    data() {
      return {
        closeIntro:true,
        clasName:''
      }
    },
    computed: {
      getCount () {
          return this.$store.getters.getStatus
      }
    },
    mounted () {
       
    },
    methods: {
        closeIntroFn(){
         this.$store.dispatch('updateStatus',false)
        },
        clickIntro(e){
          e.stopPropagation();
        }
    }
  }
</script>

<style scoped lang="scss">
    @font-face {
        font-family: 'enFont';
        src: url('../assets/font/TT0292M_.ttf')
    }

    .enFont{ font-family: 'enFont' }
    .numFont{ font-family: 'numFont' }
    .studioIntroBox{
      width: 418px;
      height: 100%;
      padding: 65px 30px;
      box-sizing: border-box;
      background-color: rgba(0,0,0,0.9);
      position: absolute;
      top: 0;
      right: 0;
      -webkit-transform: translateX(418px);
      transform: translateX(418px);
      -webkit-transition: all .5s ease;
      transition: all .5s ease;
      z-index: 9998;

      &.show{ 
        -webkit-transform: translateX(0);
      transform: translateX(0);
      -webkit-transition: all .5s ease;
      transition: all .5s ease; }

      >div{ width: 100%; height: 100%; position: relative;
        .closeBtn{ display: inline-block; position: absolute; width: 50px; height: 50px; background: url('../assets/images/icon-close.png') center no-repeat; background-size: contain; right: 0; top: 0; cursor: pointer; }

        h3{ color: #315dcd; font-size: 34px; }
        h5{ color: #afafaf; font-size: 18px; margin-top: 30px; }

        >p{ color: #afafaf; font-size: 14px; line-height:24px; margin-top: 45px;  }
        >ul{ text-align: center; margin-top: 40px;
          li{ display: inline-block; 
            &:nth-child(2){ margin: 0 45px; }
            p{ font-size: 14px; color: #afafaf; line-height: 20px; width: 70px; margin-top: 15px; }
          }
        }

        .introFoot{ margin-top: 70px;
          p{ color: #afafaf; font-size: 16px;
            &.tel{ font-size: 22px; }
            &.address{ margin-top: 10px;  }
            &.email{ margin-top: 5px; }
          }
        }
      }

      

    }

</style>



// WEBPACK FOOTER //
// src/components/StudioIntro.vue